import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import useRect from 'hooks/common/useRect';
import { Chart, layouts } from 'chart.js';

const labels = Array.from({ length: 24 + 1 }).map((_, index) => `${Math.floor(index).toString().padStart(2, '0')}00`);
const config = (hash) => ({
  type: 'bar',
  data: {
    labels,
    datasets: [
      {
        barThickness: 6,
        backgroundColor: '#347AFF',
        data: hash.values.map((value, index) => {
          return value || NaN;
        }),
      }
    ]
  },
  options: {
    layout: {
      padding: {
        left: 30,
        top: 0,
        bottom: 0,
        right: 12,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
    },
    scales: {
      x: {
        ticks: {
          maxRotation: 0,
          stepSize: 1,
          autoSkip: false,
          font: {
            family: 'Pretendard',
            weight: 400,
            size: 11,
            color: '#aaaaaa',
          },
          callback: (value) => {
            if (value % 6 !== 0) return '';
            if (/\d\d00$/.test(labels[value])) {
              return (+labels[value].replace(/00$/, '')) + 'H';
            } else {
              return '';
            }
          },
        },
        title: {
          display: false,
        },
        grid: {
          drawTicks: false,
          color: (context) => {
            if (context.type === 'tick') {
              console.log('tick', context.tick.value);
              switch (context.tick.value) {
                default:
                  return null;
              }
            } else {
              return null;
            }
          },
        },
      },
      y: {
        min: 0,
        max: 5000,
        ticks: {
          align: 'start',
          stepSize: 10,
          callback: (value, index, values) => {
            switch (value) {
              case 2000:
                return value;
              case 5000:
                return hash.type;
              default: return null;
            }
          },
        },
        title: {
          display: false,
        },
        grid: {
          drawTicks: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          title: function (context) {
            const label = (context[0].label || '').split('');
            label.splice(2, 0, ':');
            return label.join('');
          }
        },
      },
    },
  },
});

export default function ExerciseDialogStepsChart(props) {
  const {
    step_cnt_graph_list = [],
  } = props;
  const ref = React.useRef();
  const rect = useRect(ref);
  const canvasRef = React.useRef();
  const chartRef = React.useRef();

  const hash = React.useMemo(() => {
    const data = {
      values: [],
    };
    step_cnt_graph_list.forEach(item => {
      data.values.push(item.step_cnt);
    });
    data.type = T('(걸음수)');
    return data;
  }, [step_cnt_graph_list]);

  React.useEffect(() => {
    const chart = new Chart(canvasRef.current, config(hash));
    chartRef.current = chart;
    return () => {
      chart.destroy();
      delete chart.config;
    };
  }, [hash]);
  React.useLayoutEffect(() => {
    if (!chartRef.current) return;
    const frameId = requestAnimationFrame(() => {
      chartRef.current.update();
    });
    return () => {
      cancelAnimationFrame(frameId);
    };
  }, [rect]);

  return (
    <div {...ex(['Chart', 'ExerciseDialogStepsChart'], { ref })}>
      <canvas
        {...{
          ref: canvasRef,
          width: rect.width,
          height: rect.height,
        }}
      />
    </div>
  );
}
